const navigationIcons = {
  person: <><circle cx='12' cy='7' r='3.5' /><path d='M4 21v-2a8 8 0 0 1 16 0v2' /></>,
  account_circle: <><circle cx='12' cy='12' r='10' /><circle cx='12' cy='9' r='3' /><path d='M5 19a7 7 0 0 1 14 0' /></>,
  keyboard_arrow_down: <path d='m6 9 6 6 6-6' />,
  expand_more: <path d='m6 9 6 6 6-6' />,
  expand_less: <path d='m6 15 6-6 6 6' />
}

export default function MaterialIcon ({ name, className = '', filled = false, size, title, ...props }) {
  const style = size ? { fontSize: size, ...props.style } : props.style
  const classes = ['material-symbols-outlined', filled ? 'material-symbols-filled' : '', className].filter(Boolean).join(' ')

  if (navigationIcons[name]) {
    return (
      <svg className={`${classes} material-icon-vector`} viewBox='0 0 24 24' width='1em' height='1em' fill='none' stroke='currentColor' strokeWidth='1.8' strokeLinecap='round' strokeLinejoin='round' aria-hidden={title ? undefined : 'true'} role={title ? 'img' : undefined} aria-label={title} {...props} style={style}>
        {title ? <title>{title}</title> : null}
        {navigationIcons[name]}
      </svg>
    )
  }

  return (
    <span className={classes} aria-hidden={title ? undefined : 'true'} title={title} style={style} {...props}>
      {name}
    </span>
  )
}
